/**
 * Chat HUD surfaces and text, mapped from the "Interactive Chat v2" handoff onto the nearest Spice UI theme tokens:
 * surface-1 gray-2 (cards) · surface-2 gray-3 / gray-50 (sheet) · surface-4 gray-5 / gray-4 (nested boxes) ·
 * surface-5 gray-5 (tracks) · line gray-200 · line-strong #ACACAC / gray-8 (no light token is close enough) ·
 * fg-secondary blue-11 · fg-tertiary gray-10 / neutral-secondary · fg-muted gray-10 / gray-11.
 */
export const HUD_SHEET_BG = "bg-gray-3 dark:bg-gray-50";
export const HUD_LINE = "border-gray-200";
export const HUD_CARD = `flex flex-col gap-3 rounded-[12px] border ${HUD_LINE} bg-gray-2 p-3.5`;
export const HUD_BOX = "rounded-[10px] bg-gray-5 px-3 py-2.5 dark:bg-gray-4";
export const HUD_TRACK = "bg-gray-5";
export const HUD_MUTED = "text-gray-10 dark:text-gray-11";
export const HUD_TERTIARY = "text-gray-10 dark:text-neutral-secondary";
export const HUD_SECONDARY = "text-blue-11";
export const HUD_CAPS = `text-[11px] font-bold uppercase tracking-[0.08em] ${HUD_MUTED}`;
/** Highlighted row: the level the meter is on right now. */
export const HUD_CURRENT_ROW = "border-[#ACACAC] bg-gray-5 dark:border-gray-8 dark:bg-gray-4";
/** Nested icon button (info, close). */
export const HUD_ICON_BUTTON =
  "flex flex-none items-center justify-center border-0 bg-gray-5 text-gray-11 hover:bg-gray-200 hover:text-foreground dark:bg-gray-4 dark:text-blue-11 dark:hover:bg-gray-5";
/** Meter strip background (card surface). */
export const HUD_STRIP_BG = "bg-gray-2";
